import { render, staticRenderFns } from "./PausePage.vue?vue&type=template&id=1b74b916"
import script from "./PausePage.vue?vue&type=script&lang=js"
export * from "./PausePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports